<template>
  <MilestoneDetails
    :milestone="getPMileStones(project_id).find(milestone => milestone.pmilestone.id === pmilestone_id)"
    >
    <template #header="{milestone}">
      <MileStone
        class="ml-4 mt-7"
        :large="true"
        :status="getProjectMilestoneStatus({id: milestone.pmilestone.id, takt_index: milestone.takt_index, project_id})"
        type="project"
        >
        <StandardDataField
          :value="milestone.pmilestone.token"
          width="100%"
          flat="true"
          text_center="true"
          :maxlength="2"
          @changeValue="updateUObject({
              url: [
                {projects: project_id},
                {milestones: milestone.pmilestone.id}
              ],
              update: { token: $event.substring(0, 2).toUpperCase()}
            })"
          />
      </MileStone>
      <StandardDataField
        class="ml-10"
        :value="milestone.pmilestone.name"
        width="80%"
        :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
        @changeValue="updateUObject({
          url: [
            {projects: project_id},
            {milestones: milestone.pmilestone.id}
          ],
          update: { name: $event}
          })"
        />
    </template>
    <template #body="{milestone}">
      <div v-if="milestone.pmilestone.aremilestones.length === 0" style="display: flex; width: 100%; gap: 5px; justify-content: space-around; padding: 5px">
        <button v-for="status in milestoneStatus" :key="status.name"
            class="milestone-edit-button"
            :style="`${
              getProjectMilestoneStatus({id: milestone.pmilestone.id, takt_index: milestone.takt_index, project_id}) === status.name.toLowerCase() 
                ? `${status.name.toLowerCase() === 'stop' 
                  ? 'border-color: #F44336; color: #F44336;' 
                  : ($vuetify.theme.isDark ? 'border-color: white;' : 'border-color: black;')}` 
                : ''
              }`"
            @click="updateUObject({
              url: [
                {projects: project_id},
                {milestones: milestone.pmilestone.id}
              ],
              update: { status: getProjectMilestoneStatus({id: milestone.pmilestone.id, takt_index: milestone.takt_index, project_id}) === status.name.toLowerCase() ? 'none' : status.name.toLowerCase()}
              })"
        >
          <v-icon
            class="mr-1"
            small
            :color="status.name.toLowerCase() === getProjectMilestoneStatus({id: milestone.pmilestone.id, takt_index: milestone.takt_index, project_id}) && status.name.toLowerCase() === 'stop' ?'#F44336': ($vuetify.theme.isDark ? 'white' : 'black')"
          >
            {{status.icon}}
          </v-icon>
          {{status.name}}
        </button>
      </div>
      <StandardDateSelector
      :value="milestone.pmilestone.date.substring(0, 10)"
      :first_day_of_week="getFirstDayOfWeek(project_id)"
      :no_clear="true"
      @input="updateUObject({
        url: [
          {projects: project_id},
          {milestones: milestone.pmilestone.id}
        ],
        update: { date: `${$event} 12:00:00 UTC`}
        /* update: { date: `${$event} 12:23:14 UTC`} */
        })"
      :persistant="true"
      />
      <v-divider class="mt-1 mb-1"/>
      <!-- EXTERNAL ID -->

      <DisableableInputField
        class="mt-2 mb-2"
        label="EXTERNAL.id"
        :value="milestone.pmilestone.external_id"
        :is_disabled="false"
        background_color="color-3"
        @change="updateUObject({
            url: [
              {projects: project_id},
              {milestones: milestone.pmilestone.id}
            ],
            update: { external_id: $event}
          })"
      />
      <!-- LINKED MILESTONES -->
      <div style="padding-left: 3px"> Linked Milestones</div>
      <div style="display: flex; flex-direction: column; padding: 5px; gap: 20px">
        <div v-for="milestone_id in milestone.pmilestone.aremilestones" :key="milestone_id + 'b'" style="display: flex; flex-direction: row; align-items: center; height: 100%">
          <MileStone
            class="ml-4 mt-7"
            :large="true"
            type="train"
            :status="getTrainMilestoneStatus({milestone_id, project_id})"
            >
            <StandardDataField
              :value="getMileStones(project_id).find(milestone => milestone.milestone.id === milestone_id).milestone.token"
              width="100%"
              flat="true"
              :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
              text_center="true"
              :maxlength="2"
              readonly="true"
              />
          </MileStone>
          <StandardDataField
            class="ml-10"
            :value="getMileStones(project_id).find(milestone => milestone.milestone.id === milestone_id).milestone.name"
            width="80%"
            flat="true"
            :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
            readonly="true"
            />
        </div>
      </div>

    </template>
    <template #button="{milestone}">
      <div style="display: flex; flex-direction: column; gap: 5px;">
      <v-menu top :offset-y="true" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn width="100%" v-bind="attrs" v-on="on" @click="test()">
          Link Trainmilestones </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="Tmilestone in getMileStones(project_id).map(Tmilestone => Tmilestone.milestone)"
            :key="Tmilestone.id"
          >
          <div style="display: flex; flex-direction: row; align-items: center; gap: 5px">
            <input type="checkbox" :checked="milestone.pmilestone.aremilestones.includes(Tmilestone.id)" @change="updateMilestoneRelation({project_id: project_id, tM_id: Tmilestone.id, pM_id: milestone.pmilestone.id})">
            <label style="text-overflow: ellipsis"> {{Tmilestone.name}} </label>
          </div>
          </v-list-item>
        </v-list>
      </v-menu>
      <StandardDeleteButtonLarge
        @clickDelete="
        deleteMilestoneFromProject({
          project_id: project_id,
          milestone_id: milestone.pmilestone.id,
          milestone_type: 'pmilestones',
          are_milestones: milestone.pmilestone.aremilestones,
          should_milestones: milestone.pmilestone.shouldmilestones
          })
        .then(() => {
          deleteUObject({
          url: [
            {projects: project_id},
            {milestones: milestone.pmilestone.id}
          ]}).catch(() => {
            requestUObject({
              url: [
                {projects: project_id},
                {milestones: ''},
                {showWithEntitiesNormalized: ''}
              ],
              no_cache: true,
            })
            })
          })"
        >
        <v-icon>delete</v-icon>
        {{$t('Project.Milestones.DeleteMilestone')}}
      </StandardDeleteButtonLarge>
      </div>
    </template>
  </MilestoneDetails>
</template>
<script>
  import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'
  // import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue'
  import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'

  // import StandardDropdownMultiselect from '@/components/StandardComponents/StandardDropdownMultiselect.component.vue'
  export default {
    props: ['project_id', 'pmilestone_id'],
    components:{
      DisableableInputField
      // StandardOverflowButton
      // StandardDropdownMultiselect
    },
    mixins: [
      MilestonesMixin
    ],
    data () {
      return {
        milestoneStatus: [
          {name:'DONE', icon: 'done'},
          {name: 'STOP', icon: 'warning'}
        ],
        selectedMilestones: [],
      }
    },
    methods: {
      test() {
        console.table(this.selectedMilestones)
      },
      test2(id) {
        let index = this.selectedMilestones.indexOf(id)
        if (index != -1) {
          this.selectedMilestones.splice(index, 1);
        } else {
          this.selectedMilestones.push(id);
        }
      },
    }
  }
</script>
<style>
.milestone-edit-button {
  padding-left: 5px;
  padding-right: 5px;
  border: solid 1px; 
  border-radius: 5px;
  border-color: transparent;
}
</style>
